var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDindin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 3.89711C21.8329 3.2719 23.1671 3.2719 24.25 3.89711L37.7356 11.683C38.8185 12.3082 39.4856 13.4637 39.4856 14.7141V30.2859C39.4856 31.5363 38.8185 32.6918 37.7356 33.317L24.25 41.1029C23.1671 41.7281 21.8329 41.7281 20.75 41.1029L7.26443 33.317C6.18153 32.6918 5.51443 31.5363 5.51443 30.2859V14.7141C5.51443 13.4637 6.18153 12.3082 7.26443 11.683L20.75 3.89711Z",
    stroke: "#000A4A",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 8.89711C21.8329 8.2719 23.1671 8.2719 24.25 8.89711L33.4054 14.183C34.4883 14.8082 35.1554 15.9637 35.1554 17.2141V27.7859C35.1554 29.0363 34.4883 30.1918 33.4054 30.817L24.25 36.1029C23.1671 36.7281 21.8329 36.7281 20.75 36.1029L11.5946 30.817C10.5117 30.1918 9.84456 29.0363 9.84456 27.7859V17.2141C9.84456 15.9637 10.5117 14.8082 11.5946 14.183L20.75 8.89711Z",
    stroke: "white",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDindin);
export default __webpack_public_path__ + "static/media/logoDindin.d20ed7172e3b9cf1154b94624aded0f3.svg";
export { ForwardRef as ReactComponent };